import styled from '@emotion/styled';
import { CgClose } from 'react-icons/cg';

export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background:rgba(29, 29, 57, 0.5); ;

  display: flex;
  justify-content: center;

  align-items: center;
  z-index: 10;
`;

export const ModalContent = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: space-between;
  flex-direction: column;
max-height:calc(100vh - 80px);

width: 1024px;

  border-radius: 8px;
  box-shadow: 0 0 40px 0 rgba(195, 195, 195, 0.25);
  background: var(--colors-grey-25);
  padding: ${props => props.pad === "false" ? "0" : "0px"};
  position: relative;
  z-index: 1100;
@media (max-width: 689px) {
  width: 80vw;
 min-width: 342px;
 max-height:calc(100vh - 200px);
  max-height:calc(100vh - 200px);
  } 
`;

export const CloseBtn = styled(CgClose)`
  position: absolute;
  top: 14px;
  right: 14px;
  width: 24px;
  height: 24px;
  
  color: var(--colors-grey-400);
  transition: all 250ms cubic-bezier(0.4, 0, 0.2, 1);
  cursor: pointer;

  :hover {
    color: var(--accent);
  }

  @media (min-width: 767px) {
    top: 18px;
    right: 18px;
  }
`;
